import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useSelector } from 'react-redux';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

dayjs.extend(utc);
dayjs.extend(timezone);

const InputDateTimeUTC = ({
  clearable = false,
  id,
  label,
  name,
  placeholder,
  value,
  error,
  onBlur,
  onChange,
  disabled,
  maxDate,
  minDate,
  format = 'DD/MMM/YYYY',
  helperText,
  size,
  variant = 'standard'
}) => {
  const timezone = useSelector((state) => state.tenant?.timezone || 'Australia/Victoria');

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        id={id}
        label={label}
        name={name}
        placeholder={placeholder}
        value={value ? dayjs(value).tz(timezone) : null} // Display date in user's timezone
        disabled={disabled}
        format={format || 'DD/MMM/YYYY'}
        onChange={(selectedDate) => {
          if (!selectedDate) {
            onChange(null);
            return;
          }
          const utcDate = selectedDate.tz(timezone).utc();
          onChange(utcDate.toISOString());
        }}
        onBlur={onBlur}
        timezone={timezone}
        slotProps={{
          textField: {
            variant,
            error,
            helperText: helperText,
            fullWidth: true,
            disabled,
            size,
          },
          field: {
            clearable,
            onClear: () => onChange(null)
          }
        }}
        maxDate={maxDate ? dayjs(maxDate).tz(timezone) : undefined}
        minDate={minDate ? dayjs(minDate).tz(timezone) : undefined}
      />
    </LocalizationProvider>
  );
};

export default InputDateTimeUTC;
